import { isDev } from './config.js';

// if (isDev) {
//   // 保存原始Promise引用
//   const OriginalPromise = Promise;

//   // 重写Promise构造函数
//   Promise = function (executor) {
//     const timeoutMs = 10 * 1000; // 默认3秒超时
//     let timeoutId;

//     // 创建超时Promise
//     const timeoutPromise = new OriginalPromise((_, reject) => {
//       timeoutId = setTimeout(() => {
//         reject(new Error(`Promise超时 (${timeoutMs}ms)`));
//         console.log('超时的Promise:', executor); // 打印超时Promise对象
//       }, timeoutMs);
//     });

//     // 包装原始Promise
//     const wrappedPromise = new OriginalPromise(executor);

//     // 清理超时计时器
//     wrappedPromise.finally(() => clearTimeout(timeoutId));

//     // 返回竞速结果
//     return OriginalPromise.race([wrappedPromise, timeoutPromise]);
//   };

//   // 保持原型链
//   Promise.prototype = OriginalPromise.prototype;
//   Promise.all = OriginalPromise.all;
//   Promise.race = OriginalPromise.race;
//   Promise.resolve = OriginalPromise.resolve;
//   Promise.reject = OriginalPromise.reject;
//   console.log('Promise 测试环境重写 已加载');
// }

// polyfill
if (typeof atob === 'undefined') {
  // polyfill for atob
  window.atob = function (input) {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let str = String(input).replace(/=+$/, '');
    let output = '';

    if (str.length % 4 === 1) {
      throw new Error(
        "'atob' failed: The string to be decoded is not correctly encoded."
      );
    }
    for (
      let bc = 0, bs = 0, buffer, i = 0;
      (buffer = str.charAt(i++));
      ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
        ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
        : 0
    ) {
      buffer = chars.indexOf(buffer);
    }

    return output;
  };
}
